import arrowDown from './arrow-down.svg';
import arrowUp from './arrow-up.svg';
import adicionar from './ic_adicionar.svg';
import avatar from './ic_avatar.svg';
import aviso from './ic_aviso.svg';
import btnAvatar from './ic_btnavatar.svg';
import btnPesquisa from './ic_btnpesquisa.svg';
import closeMenu from './ic_closemenu.svg';
import icDelete from './ic_delete.svg';
import documento from './ic_documento.svg';
import download from './ic_download.png';
import apagar from './ic_dropapagar.svg';
import calendario from './ic_dropcalendario.svg';
import down from './ic_dropdown.svg';
import filtro from './ic_dropfiltro.svg';
import tabelaMostrar from './ic_droptabela_mostrar.svg';
import tabelaOcultar from './ic_droptabela_ocultar.svg';
import up from './ic_dropup.svg';
import enviar from './ic_enviar.svg';
import erro from './ic_erro.svg';
import hamburguerMenu from './ic_hamburguermenu.svg';
import imprimir05x from './ic_imprimir05x.svg';
import imprimir1x from './ic_imprimir@1x.png';
import imprimir2x from './ic_imprimir@2x.png';
import imprimir3x from './ic_imprimir@3x.png';
import sair from './ic_sair.svg';
import salvar from './ic_salvar.svg';
import setaCarrocel from './ic_setacarrocel.svg';
import setaTabela from './ic_setatabela.svg';
import sucesso from './ic_sucesso.svg';
import upload from './ic_upload.svg';
import vermais from './ic_vermais.svg';
import show from './show.svg';
import extratos from './ic_extratos.svg';
import checkup from './ic_checkup.svg';
import transferencias from './ic_transferencias.svg';
import pagarFatura from './ic_pagarfatura.svg';
import extratosWhite from './ic_extratos_white.svg';
import checkUpWhite from './ic_checkup_white.svg';
import transferenciasWhite from './ic_transferencias_white.svg';
import pagarFaturaWhite from './ic_pagarfatura_white.svg';
import snsJaTableIcon from './ic_snsja.svg';
import resolvaJaTableIcon from './ic_resolvaja.svg';
import recebaJaTableIcon from './ic_recebaja.svg';
import confirmeJaTableIcon from './ic_confirmeja.svg';
import avanceJaTableIcon from './ic_avanceja.svg';
import finanFarmaTableIcon from './ic_finanfarma.svg';
import phone from './ic_phonecard.svg';
import mail from './ic_mailcard.svg';
import approve from './ic_aprovar.svg';
import reject from './ic_rejeitar.svg';
import tooltip from './ic_tooltip.svg';

export const arrowDownIcon = arrowDown;
export const arrowUpIcon = arrowUp;
export const adicionarIcon = adicionar;
export const avatarIcon = avatar;
export const avisoIcon = aviso;
export const btnAvatarIcon = btnAvatar;
export const btnPesquisaIcon = btnPesquisa;
export const closeMenuIcon = closeMenu;
export const icDeleteIcon = icDelete;
export const documentoIcon = documento;
export const downloadIcon = download;
export const apagarIcon = apagar;
export const calendarioIcon = calendario;
export const downIcon = down;
export const filtroIcon = filtro;
export const tabelaMostrarIcon = tabelaMostrar;
export const tabelaOcultarIcon = tabelaOcultar;
export const upIcon = up;
export const enviarIcon = enviar;
export const erroIcon = erro;
export const hamburguerMenuIcon = hamburguerMenu;
export const imprimir05xIcon = imprimir05x;
export const imprimir1xIcon = imprimir1x;
export const imprimir2xIcon = imprimir2x;
export const imprimir3xIcon = imprimir3x;
export const sairIcon = sair;
export const salvarIcon = salvar;
export const setaCarrocelIcon = setaCarrocel;
export const setaTabelaIcon = setaTabela;
export const sucessoIcon = sucesso;
export const uploadIcon = upload;
export const vermaisIcon = vermais;
export const showIcon = show;
export const extratosIcon = extratos;
export const checkupIcon = checkup;
export const transferenciasIcon = transferencias;
export const pagarFaturaIcon = pagarFatura;
export const extratosWhiteIcon = extratosWhite;
export const checkUpWhiteIcon = checkUpWhite;
export const transferenciasWhiteIcon = transferenciasWhite;
export const pagarFaturaWhiteIcon = pagarFaturaWhite;
export const snsJaTable = snsJaTableIcon;
export const resolvaJaTable = resolvaJaTableIcon;
export const confirmeJaTable = confirmeJaTableIcon;
export const recebaJaTable = recebaJaTableIcon;
export const avanceJaTable = avanceJaTableIcon;
export const finanFarmaTable = finanFarmaTableIcon;
export const phoneIcon = phone;
export const mailIcon = mail;
export const approveIcon = approve;
export const rejectIcon = reject;
export const tooltipIcon = tooltip;
